import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FilterDialogComponent } from './manage-user-filter-dialog/manage-user-filter-dialog.component';
import { ManageUserDialogComponent } from './manage-user-dialog/manage-user-dialog.component';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { PrivilegeCellComponent } from '../../../table-cell/privilege-cell.component';
import { ManageButtonComponent } from '../../../table-cell/manage-user-button-cell.component';
import { ManageUserService } from '../../../services/raintree/Transmission/manage-user.service';
import { SearchService } from '../../../services/common/search.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DpInputFieldComponent } from '../../../common-component/dp-input-field/dp-input-field.component';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { MatSelectModule } from '@angular/material/select';
import { AppConfigService } from '../../../services/config/app-config.service';
import { DistrictListService } from '../../../services/raintree/Transmission/district-list.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DpLoaderComponent } from '../../../common-component/dp-loader/dp-loader.component';
import { catchError, concatMap, debounceTime, filter, forkJoin, map, of, Subject, switchMap, tap } from 'rxjs';
import { SatesListService } from '../../../services/raintree/Transmission/sates-list.service';
import { response } from 'express';
import { AdjustableLoaderComponent } from '../../../common-component/adjustable-loader/adjustable-loader.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

interface User {
  address: string;
  blocked: number;
  contact_number: string;
  district_name: string;
  email_id: string;
  first_name: string;
  id: number;
  last_name: string;
  permissions: string;
  pincode: string;
  role_name: string;
  state_code: string;
  state_name: string;
  verified: number;
  fw_role_count?: number;
  da_role_count?: number;
  sa_role_count?: number;
  // ukw_role_count?: number;
  mw_role_count?: number;
  dpu_role_count?: number;
  jk_role_count?: number;
  adj_role_count?: number;
  spr_role_count?: number;
  pr_role_count?: number;
  ra_role_count?: number;
  su_role_count?: number;
}

@Component({
  selector: 'app-manage-user',
  standalone: true,
  imports: [
    MatIconModule,
    MatDividerModule,
    CommonModule,
    DpTableComponent,
    FormsModule,
    ReactiveFormsModule,
    DpInputFieldComponent,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    DpLoaderComponent,
    InfiniteScrollModule,
    AdjustableLoaderComponent
  ],
  templateUrl: './manage-user.component.html',
  styleUrls: [
    './manage-user.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
})
export class ManageUserComponent implements OnInit {
  public placeholder: string = 'Search by username/email address';
  isMobileView: boolean = false;
  datatable: any = [];
  tempData: any = [];
  states: any = [];
  districts: { [key: string]: any[] } = {};
  tempDistricts: { [key: string]: any[] } = {};
  selectedState: string = '';
  selectedDistrict: string = '';
  permissions: any;
  toggleFilter: boolean = false;
  locationAccess: any;
  isLoader: boolean = false;
  seamerTable: any = [];
  numberOfLoaders: number = 20;
  isSuperUser: boolean = false;
  isLoading: boolean = false;
  pageNo: number = 1;
  isScrollable: boolean = true;
  private inputSubject = new Subject<string>();
  searchTerm = new FormControl<string>('');

  levels: string[] = ["ALL LEVEL"];
  selectedLevel: string = "ALL LEVEL";

  constructor(
    public dialog: MatDialog,
    private _searchService: SearchService,
    private _manageUserService: ManageUserService,
    private isMobile: CommonUtilService,
    private getManageUser: ManageUserService,
    private _appconfig: AppConfigService,
    public districtTransmissionService: DistrictListService,
    public stateTransmissionService: SatesListService,
    public stateListService: SatesListService,
    public districtListService: DistrictListService
  ) {
    this.seamerTable = [];
  }
  // searchTerm: string = '';
  ngOnInit() {
    this.isMobileView = this.isMobile.isMobileDevice();
    this.locationAccess = this._appconfig.fetchManageUsersData();
    this.states = this.locationAccess.states;
    this.districts = this.locationAccess.districts;
    this.isSuperUser = this.locationAccess.isSuperUser;
    this.searchTerm.valueChanges.pipe(
      debounceTime(600),
    ).subscribe((data: any) => {
      if (data?.length >= 3 || data?.length == 0) {
        this.fetchUsers(true)
      }
    })

    this.loadPermissionLevels();
    console.log(this.states, this.districts)
    if (this.states.length === 0) {
      this.isLoading = true;
      this.stateTransmissionService.getStatesList().pipe(
        map((response: any) => response.data.map((elm: any) => elm.stateName)),
        tap(states => {
          this.states = states;
        }),
        // concatMap(() => {
        //   const districtFetchObservables = this.states.map((state: any) => {
        //     if (!this.districts[state] || this.districts[state].includes('ALL')) {
        //       return this.districtTransmissionService.getDistrictList(state).pipe(
        //         map((response: any) => response.data.map((elm: any) => elm.district_name)),
        //         tap(districts => {
        //           this.districts[state] = districts;
        //           console.log(this.districts[state],'dists=====');
        //         }),
        //         catchError(() => of({ state, districts: [] }))
        //       );
        //     }
        //     else {
        //       return of(null);
        //     }
        //   });

        //   return forkJoin(districtFetchObservables);
        // })
      ).subscribe({
        next: (districtResults: any) => {
          this.isLoading = false;
          this.handleStateAndDistrictSelection();
          // this.fetchUsers(true);
        },
        error: (error) => {
        }
      });
    } else {

      const districtFetchObservables = this.states.map((state: any) => {
        if (!this.districts[state] || this.districts[state].includes('ALL')) {
          return this.districtTransmissionService.getDistrictList(state).pipe(
            map((response: any) => response.data.map((elm: any) => elm.district_name)),
            tap(districts => {
              this.districts[state] = districts;
            }),
            catchError(() => of({ state, districts: [] }))
          );
        }
        else {
          return of(null);
        }
      });

      forkJoin(districtFetchObservables).subscribe({
        next: (districtResults: any) => {
          this.handleStateAndDistrictSelection();
          // this.fetchUsers(true);
        },
        error: (error) => {
        }
      });
    }
  }
  onScroll(event: any): void {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight && this.isScrollable) {
      this.isLoading = true;
      this.pageNo++;
      this.fetchUsers(false);
    }
  }
  handleStateAndDistrictSelection(): void {
    this.selectedState = '';
    this.selectedDistrict = '';
    this.fetchUsers(true);
  }

  openFilterDialog(): void {
    // this.dialog.open(FilterDialogComponent);
    const dialogRef = this.dialog.open(FilterDialogComponent, {
      autoFocus: false,
      data: {
        stateList: this.states,
        districtList: this.districts,
        selectedState: this.selectedState,
        selectedDistrict: this.selectedDistrict,
        levelList: this.levels,
        selectedLevel: this.selectedLevel
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.selectedState = result.selectedState;
        this.selectedDistrict = result.selectedDistrict;
        this.selectedLevel = result.selectedLevel;
        console.log("Fetching user list!!!")
        this.fetchUsers(true);
      }
    });
  }

  public displayColumnData: any = [
    {
      id: 'name',
      name: 'Name',
    },
    {
      id: 'email',
      name: 'Email',
    },
    {
      id: 'contact',
      name: 'Contact',
    },
    {
      id: 'district',
      name: 'District',
    },
    // {
    //   id: 'role',
    //   name: 'Role',
    // },
    {
      id: 'status',
      name: 'Status',
    },
    {
      id: 'privilege',
      name: 'Privilege',
    },
    {
      id: 'manage',
      name: '',
      width: '250px',
    },
  ];

  cellComponentMap = {
    manage: ManageButtonComponent,
    privilege: PrivilegeCellComponent,
  };

  onScrollTable() {
    if (this.isScrollable) {
      this.pageNo++;
      this.fetchUsers(false);
    }
  }
  fetchUsers(isStart?: boolean): void {
    this.isLoading = true;
    if (isStart) {
      this.pageNo = 1;
      this.isScrollable = true;
    }
    let paramsObj: any = {};
    paramsObj.page = this.pageNo;
    if (this.selectedState != '') {
      paramsObj.state = this.selectedState;
    }
    if (this.selectedDistrict != '') {
      paramsObj.district = this.selectedDistrict === 'all' ? null : this.selectedDistrict;
    }

    if (this.searchTerm.valid) {
      paramsObj.searchInput = this.searchTerm.value
    }
    if (isStart) this.isLoader = true; 
    if (this.selectedLevel !== "ALL LEVEL") paramsObj.level = this.selectedLevel;
    this._manageUserService.fetchManageUser(paramsObj).subscribe({
      next: (response: any) => {
        if (response.data.length === 0) {
          this.isScrollable = false;
        }
        this.isLoading = false;
        this.datatable = response.data.map((item: User) => ({
          id: item.id,
          name: `${item.first_name} ${item.last_name}`,
          email: item.email_id,
          contact: item.contact_number,
          district: item.district_name,
          state: item.state_name,
          role: item.role_name,
          status: item.verified ? 'Active' : 'Inactive',
          privilege: item.blocked ? 'Blocked' : 'Unblocked',
          pincode: item.pincode,
          fw_role_count: item.fw_role_count,
          da_role_count: item.da_role_count,
          sa_role_count: item.sa_role_count,
          // ukw_role_count: item.ukw_role_count,
          mw_role_count: item.mw_role_count,
          dpu_role_count: item.dpu_role_count,
          jk_role_count: item.jk_role_count,
          adj_role_count: item.adj_role_count,
          spr_role_count: item.spr_role_count,
          pr_role_count: item.pr_role_count,
          ra_role_count: item.ra_role_count,
          su_role_count: item.su_role_count,
          address: item.address
        }));
        if (!isStart) {
          this.tempData = [...this.tempData, ...this.datatable];
        }
        else {
          this.tempData = this.datatable;
        }
        this.datatable = this.tempData;
        this.isLoader = false;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoader = false;
        this.isLoading = false;
      },
    });
  }

  openDialog(rowData: any) {
    const dialogRef = this.dialog.open(ManageUserDialogComponent, {
      autoFocus: false,
      data: {
        userDetails: rowData,
        isSuperUser: this.isSuperUser,
        states: this.states,
        districts: this.districts,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.fetchUsers(true);
    });
  }

  openDialogMobile(rowData: any) {
    // if(!this.isMobileView){
    const dialogRef = this.dialog.open(ManageUserDialogComponent, {
      data: {
        userDetails: rowData,
        selectedDistrict: this.selectedDistrict,
        selectedState: this.selectedState,
        isSuperUser: this.isSuperUser,
        states: this.states,
        districts: this.districts,
      },
      width: '85vw',
      maxWidth: '85vw',
      height: '90vh',
      maxHeight: '90vh',
      panelClass: 'full-screen-dialog',
    });
    dialogRef.afterClosed().subscribe((result) => { });
    // }else {
    //   alert("Please user the DP Work Mobile App For Manage user 🙏")
    // }
  }

  onInputChange(event: any) {
    if (event != '') {
      this.datatable = this._searchService.filterData(
        this.datatable,
        event,
        this.displayColumnData
      );
    } else {
      this.datatable = this.tempData;
    }
  }

  getDistrictList(state: any) {
    if (!this.locationAccess.states) {
      this.districtListService.getDistrictList(state).subscribe({
        next: (response: any) => {
          if (!response.error) {
            let resp = response.data;
            this.districts[state] = [];
            //////////////////////////left at here the work is remaining
            resp.forEach((item: any) => {
              this.districts[state].push(item.district_name);
            });
          }
        },
        error: (error) => {
        },
      });
    }
  }

  loadPermissionLevels() {
    this._manageUserService.fetchManagablePermissionLevels().subscribe({
      next: (response: any) => {
        if (response.data) {
          this.levels.push(...response.data);
        }
      },
      error: (error: any) => {
        this.isLoading = false;
      },
    })
  }
}
